/* Media API — dispatches to the mock or the real HTTP backend. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './media.mock'
import * as http from './media.http'

export type { AddMediaInput } from './media.mock'

const impl = USE_MOCK_API ? mock : http

export const listMedia = impl.listMedia
export const addMedia = impl.addMedia
export const deleteMedia = impl.deleteMedia
